export const LineByLineSVG = ({ color = "black" }) => (
  <div style={{ width: "20px", height: "16px" }}>
    <svg width="18" height="18" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="2" cy="4" r="1" fill={color} />
      <circle cx="2" cy="10" r="1" fill={color} />
      <circle cx="2" cy="16" r="1" fill={color} />
      <rect x="4" y="3" width="15" height="2" rx="1" fill={color} />
      <rect x="4" y="9" width="15" height="2" rx="1" fill={color} />
      <rect x="4" y="15" width="15" height="2" rx="1" fill={color} />
    </svg>
  </div>
);
